import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ISettingsState }       from 'Redux/Slices/Settings/SettingsSlice';
import { Event }                from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findSettingsRequest = (state: Draft<ISettingsState>, { type }: PayloadAction) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findSettingsSuccess = (state: Draft<ISettingsState>, { type, payload }: PayloadAction<{
  options: Record<string, unknown>
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, ...payload.options };

};

export const findSettingsFailure = (state: Draft<ISettingsState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
